import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const ThankYou = () => {
    useEffect(() => {
        AOS.init({
          duration: 1000,
          offset: 100,
        });
    }, []);

    return (
        <>
            <section className="getInvolved-banner">
                <div data-aos="zoom-out-down" className="container">
                    <div  style={{height: '70vh'}} className="col-12 text-center d-flex justify-content-center align-items-center">
                        <div className="col-6">
                            <h1 style={{color: '#fe5e00', fontSize: "2.1rem"}}>Thank You!</h1>
                            <div style={{fontSize: '1rem', lineHeight: '22px'}}>We appreciate your interest in becoming a volunteer. 
                                A confirmation email with further details has been sent to your inbox. Please check your email for the next steps, and feel free to reach out if you need any assistance.</div>
                            <div className="mt-5 d-flex justify-content-center">
                                <a href="/mahasangam-yatra" className="top-button no-underline" >
                                <button>Go to Home</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    
                </div>
                
            </section>
        </>
    )
}

export default ThankYou;